<template>
  <div>
    <viewTable
        ref="viewTable"
        :columns-property="columnsProperty"
        :filter="filter"
        :limits="limits"
        :table-select="false"
        module="basic"
        url="inspectionBills"
        @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="单据编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入单据编号" clearable/>
          </el-form-item>
          <el-form-item label="关联单号">
            <el-input v-model.trim="filter.relBillNo" placeholder="请输入关联单号" clearable/>
          </el-form-item>
          <el-form-item label="检验状态">
            <el-select v-model="filter.status" placeholder="检验状态" clearable>
              <el-option label="未检验" :value="0"/>
              <el-option label="已检验" :value="1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="汇报状态">
            <el-select v-model="filter.reportStatus" placeholder="汇报状态" clearable>
              <el-option label="未汇报" :value="0"/>
              <el-option label="已汇报" :value="1"/>
            </el-select>
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
                v-model="createTime"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="createDateChange"
            />
          </el-form-item>
          <el-form-item label="检验日期">
            <el-date-picker
                v-model="checkDate"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="checkDateChange"
            />
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="{ row }">
        <el-button v-if="limits.checkAuth" type="primary" @click="handleCheck(row)">检验</el-button>
        <el-button v-if="limits.reportAuth" type="success" :loading="row.reportLoading" @click="handleReport(row)">汇报</el-button>
      </template>
    </viewTable>
    <task-process-inspection-edit ref="editPage" @save-success="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import taskProcessInspectionEdit from "@/views/InspectionManagement/TaskProcessInspection/TaskProcessInspectionEdit";
  export default {
    name: "TaskProcessInspectionList",
    components: { viewTable, taskProcessInspectionEdit },
    data() {
      return {
        limits: {
          reportAuth: this.$auth(404),
          checkAuth: this.$auth(403),
        },
        filter: {
          billNo: "",
          relBillNo: "",
          status: "",
          reportStatus: "",
          resportStatus: "",
          documentStartDate: "",
          documentEndDate: "",
          createStartTime: "",
          createEndTime: "",
        },
        createTime: "",
        checkDate: "",
        columnsProperty: [
          {
          tooltip: true,
            key: "billNo",
            width: 150,
            align: "center",
            render: (h, params) => {
              return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.editPage.open(params.row, true);
                    },
                  },
                },
                params.row.billNo
              );
            },
          },
          {
          tooltip: true,
            key: "taskDispatchBillNo",
            width: 150,
            align: "center",
          },
          {
          tooltip: true,
            key: "statusName",
            width: 120,
            align: "center",
          },
          {
          tooltip: true,
            key: "reportStatusName",
            width: 120,
            align: "center",
          },
          {
          tooltip: true,
            key: "creatorName",
            width: 120,
            align: "center",
          },
          {
          tooltip: true,
            key: "createTime",
            width: 180,
            align: "center",
          },
          {
          tooltip: true,
            key: "inspectorName",
            width: 120,
            align: "center",
          },
          {
          tooltip: true,
            key: "documentDate",
            width: 140,
            align: "center",
          },
          {
          tooltip: true,
            key: "note",
            minWidth: 200,
          },
          {
            key: "action",
            slot: "action",
            width: 160,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      resetHandle(filter) {
        this.filter = filter;
        this.createTime = "";
        this.checkDate = "";
      },

      //检验
      handleCheck(row) {
        if (row.reportStatus === 1) {
          this.$confirm("请选择未汇报的数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$refs.editPage.open(row, false);
        }
      },

      // 汇报
      handleReport(row) {
        if (row.reportStatus === 1) {
          this.$confirm("请选择未汇报的数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else if (row.status === 0) {
          this.$confirm("请选择已检验的数据", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$set(row, "reportLoading", true);
          let param = {
            id: row.pkId,
          };
          this.$http.post("basic", "inspectionBills", null, param).then((res) => {
            if (res.success) {
              this.$message.success("操作成功");
              this.loadData();
            }
            this.$set(row, "reportLoading", false);
          });
        }
      },

      createDateChange(date) {
        if (date) {
          this.filter.createStartTime = date[0];
          this.filter.createEndTime = date[1];
        } else {
          this.filter.createStartTime = "";
          this.filter.createEndTime = "";
        }
      },

      checkDateChange(date) {
        if (date) {
          this.filter.documentStartDate = date[0];
          this.filter.documentEndDate = date[1];
        } else {
          this.filter.documentStartDate = "";
          this.filter.documentEndDate = "";
        }
      },
    },
  };
</script>

<style scoped></style>
